import { useIsPC } from '~/lib/ua'
import { css, cx } from '~/styled-system/css'
import { flex } from '~/styled-system/patterns'

export function IkyuDayBanner() {
  const isPC = useIsPC()
  return (
    <div
      className={cx(
        flex({
          fontWeight: 'bold',
          lineHeight: 'none',
          w: 'full',
          h: '[32px]',
          _pc: { h: '[20px]' },
        }),
        '*:flex *:items-center *:border-y *:border-carrot-light'
      )}
    >
      <div
        className={css({
          borderStart: 'medium',
          borderStartRadius: 'md',
          bgColor: 'not.recommended.ikyu.carrot.basic',
          _pc: {
            borderStartRadius: 'sm',
          },
        })}
      >
        <div
          className={css({
            color: 'white',
            px: '3',
            fontSize: { base: 'base', _pc: 'xs' },
            _pc: {
              px: '3',
            },
          })}
        >
          24時間限定
        </div>
      </div>
      <div
        className={css({
          flex: '1',
          justifyContent: 'center',
          borderEnd: 'medium',
          borderEndRadius: 'md',
          bgColor: 'white',
          _pc: {
            borderEndRadius: 'sm',
          },
        })}
      >
        <div
          className={css({
            color: 'not.recommended.ikyu.carrot.dark',
            fontSize: { base: 'sm', _pc: 'xs' },
            _pc: { px: '3' },
          })}
        >
          {isPC ? 'ポイントアップ中！' : '今なら最大1,000円分にポイントアップ中'}
        </div>
      </div>
    </div>
  )
}
